import { style } from '@vanilla-extract/css';

export const regexHelpAction = style({
  marginLeft: 'auto',
});
